import { registerModal } from 'features/Modal/ModalRegistry'
import { ContactCreateModal } from './ContactCreateModal'
import { showModal } from 'features/Modal/Modal.actions'

export interface IContactCreateModalActionProps {
  phoneNumber?: string
}

export const modalType = 'CREATE_CONTACT_MODAL'
registerModal(modalType, ContactCreateModal)
export const showContactCreateModal = (modalProps: IContactCreateModalActionProps) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// src/features/Contacts/ContactCreateModal/ContactCreateModal.action.ts